import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef, useState } from "react"
import {
  Row,
  Col,
  // CardBody,
  // Card,
  Alert,
  // Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import SocialLinkUpdate from "./SocialLink/SocialLinkUpdate"

import { Link, useLocation, useNavigate } from "react-router-dom"
import withRouter from "../../components/Common/withRouter"

// import images
import logo from "assets/images/logo-dark.png"
import logolight from "assets/images/logo-light.png"
import logoLg from "assets/images/header-logo-lg.svg"
import { Bounce, toast } from "react-toastify"
import SocialLink from "./SocialLink/SocialLink"
import { post } from "../../api/axios"
import endpoints from "../../api/endpoints"
const VerifyEmail = props => {
  document.title = " VerifyEmail | Dock Tok"
  const navigate = useNavigate()
  const location = useLocation()
  const queryString = location.search
  const params = new URLSearchParams(queryString)
  const [email, setEmail] = useState(location?.state?.email)
  const [timer, setTimer] = useState(10)
  const timeoutRef = useRef(null)

  const timeOutCallback = useCallback(() => {
    setTimer(currTimer => Math.max(currTimer - 1, 0))
  }, [])

  useEffect(() => {
    if (timer > 0) {
      timeoutRef.current = setTimeout(timeOutCallback, 1000)
    }

    return () => clearTimeout(timeoutRef.current)
  }, [timer, timeOutCallback])

  const resetTimer = () => {
    if (timer === 0) {
      setTimer(10)
    }
  }
  const resend = async () => {
    const resp = await post(`${endpoints.resendEmailVerification}`, {
      email: email,
    })
    if (resp?.data?.success) {
      toast.success(resp?.data?.message, {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      })
      resetTimer()
    }
  }

  const handleClick = () => {
    navigate("/admin")
  }

  // const dispatch = useDispatch()

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      code: "",
    },
    validationSchema: Yup.object({
      code: Yup.string().required("Please enter OTP"),
    }),
    onSubmit: async values => {
      // dispatch(loginUser(values, props.router.navigate))
      const response = await post(endpoints.sendEmailOtp, values)
      console.log("response", response?.data)
      if (response?.data?.success) {
        navigate("/login")
        toast.success(response?.data?.message, {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        })
      } else {
        toast.error(response?.response?.data?.error, {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        })
      }
    },
  })
  useEffect(() => {
    // dispatch(apiError(""))
    document.body.className = "authentication-bg"
    // remove classname when component will unmount

    return function cleanup() {
      document.body.className = ""
    }
  }, [])
  const error = null

  return (
    <Row className="row-gap-2 row-gap-md-4 mx-md-5 mx-lg-0 px-md-5 my-5 py-0 login-scroll">
      <Col lg={12}>
        <div className="text-center">
          <Link to="/" className="mb-3 d-block auth-logo mt-5 mt-md-5 mt-lg-5 ">
            <img src={logo} alt="" height="80" className="logo logo-light" />
            <img src={logoLg} alt="" height="80" className="logo logo-dark" />
          </Link>
        </div>
      </Col>

      <Col xs="12" lg="12">
        <div className="text-center mt-2">
          <h5 className="text-primary text-uppercase">Verify your Email</h5>
          <p className="text-muted">
            Enter the code you get in email ("{email}").
          </p>
        </div>
        <div className="p-2 mt-4 ">
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            {error ? <Alert color="danger">{error}</Alert> : null}

            <div className="mb-3">
              <Input
                autoComplete="off"
                name="code"
                className="form-control"
                placeholder="Enter your code"
                type="code"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.code || ""}
                invalid={
                  validation.touched.code && validation.errors.code
                    ? true
                    : false
                }
              />
              {validation.touched.code && validation.errors.code ? (
                <FormFeedback type="invalid">
                  {validation.errors.code}
                </FormFeedback>
              ) : null}
            </div>

            <div className="mt-3">
              <button
                className="btn btn-primary w-100 waves-effect waves-light"
                type="submit"
              >
                Submit
              </button>
            </div>
            {!timer && (
              <div className="mt-1 mb-0">
                <Link
                  className="pre-text"
                  type="button"
                  onClick={e => {
                    // Handle resend OTP functionality here
                    resend()
                  }}
                >
                  Resend OTP ?
                </Link>
              </div>
            )}
            {timer > 0 && (
              <div className="mt-1 gray-700">
                <span>You Can Resend OTP in 00:{timer}</span>
              </div>
            )}
            <div className="mt-3 text-center">
              <p>
                Already have an account?
                <Link to="/login">
                  <i>
                    <strong>Login</strong>
                  </i>
                </Link>{" "}
              </p>
            </div>
          </Form>
        </div>
      </Col>

      <div className="d-flex d-md-none justify-content-center">
        <button className="btn btn-primary-green" onClick={handleClick}>
          LOGIN AS ADMIN
        </button>
      </div>
    </Row>
  )
}
export default withRouter(VerifyEmail)

VerifyEmail.propTypes = {
  registerUser: PropTypes.func,
  // registerUserFailed: PropTypes.func,
  registrationError: PropTypes.any,
  user: PropTypes.any,
}
